import React from "react"
import PropTypes from "prop-types"
import { ResponsiveLine } from '@nivo/line'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'


export default function LineChart(props) {
  const breakpoints = useBreakpoint();
  const chartData = []

  // This is bad but there is a time crunch
  // look for the qID of total and set percentage to no. The qID is set in multiyear.xml for this particular dataset
  const usePercent = props.qID === 'total' ? false : true

  props.xmlChildren.map(child => {

    // eslint-disable-next-line no-prototype-builtins
    if(child.hasOwnProperty("children")){
      return (
        chartData.push({
          "id": child.attributes.response,

          "data": child.children.map(yearData => {
            return (
              {
                "x": Number(yearData.content),
                "y": Number(usePercent ? yearData.attributes.percent : yearData.attributes.total)
              }
            )
          })
        })
      )
    } else {
       return (
        <article className="message is-danger"><div className="message-body">There was an error with this line chart. Probably missing multiyear data.</div></article>
       )
    }
  })

  const legendSettings = [
    {
      anchor: 'bottom-left',
      direction: props.xmlChildren.length > 2 ? 'column' : 'row',
      justify: false,
      translateX: -10,
      translateY: breakpoints.sm ? 200 : 140,
      itemsSpacing: 0,
      itemDirection: 'left-to-right',
      itemWidth: 80,
      itemHeight: 20,
      itemOpacity: 0.75,
      symbolSize: 12,
      symbolShape: 'circle',
      symbolBorderColor: 'rgba(0, 0, 0, .5)',
      effects: [
        {
          on: 'hover',
          style: {
            itemBackground: 'rgba(0, 0, 0, .03)',
            itemOpacity: 1
          }
        }
      ]
    }
  ]



  const marginBottom = props.uses_legend ? props.xmlChildren.length > 2 ? 180 : 150 : 80

  return (
    <ResponsiveLine
      data={chartData}
      margin={{ top: 50, right: 15, bottom: marginBottom, left: 55 }}
      xScale={{ type: 'point' }}
      yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: breakpoints.sm ? 90 : 0,
          legend: 'Year',
          legendOffset: 60,
          legendPosition: 'middle'
      }}
      axisLeft={{
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: usePercent ? 'Percent' : 'Total',
          legendOffset: -50,
          legendPosition: 'middle'
      }}
      // colors={props.custom_scheme}
      colors={{ scheme: 'paired' }}
      pointSize={9}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      lineWidth={3}
      pointBorderColor={{ from: 'serieColor', modifiers: [] }}
      pointLabel="y"
      pointLabelYOffset={-12}
      useMesh={true}
      enableSlices='x'
      animate={false}
      legends={props.uses_legend ? legendSettings : []}
    />
  )
}

LineChart.propTypes = {
  xmlChildren: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  uses_legend: PropTypes.bool.isRequired,
  custom_scheme: PropTypes.array.isRequired,
  qID: PropTypes.string.isRequired
}

LineChart.defaultProps = {
  xmlChildren: [],
  question: null,
  uses_legend: false,
}
